<template>
    <div>
      <el-tabs v-model="activeName" type="card" style="margin: 0 40px 0 40px;">
        <el-tab-pane label="杭州云仓库存" name="cloudws">
          <el-table
            stripe
            id="ycorderdataid"
            :header-cell-style="{'text-align':'center'}"
            :data="goodsdata"
            ref="multipleTable">
            <el-table-column
              prop="goodsname"
              label="产品名称">
            </el-table-column>
            <el-table-column
              prop="product_code"
              label="条码">
            </el-table-column>
            <el-table-column
              prop="qty_available"
              label="库存数">
            </el-table-column>
            <el-table-column
              prop="qty_on_location"
              label="本地库存数">
            </el-table-column>
            <el-table-column
              label="操作"
              width="50px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="更改库存" placement="top-start">
                  <el-popover
                    placement="left"
                    width="260"
                    ref="popover"
                    trigger="click"
                    :value="showpop">
                    <div>
                      <el-select v-model="wsid" placeholder="请选择库房">
                        <el-option
                          v-for="item in wslist"
                          :key="item.id"
                          @click.native="selws(item)"
                          :label="item.sname"
                          :value="item.id">
                        </el-option>
                      </el-select>
                      <el-input style="margin-top: 10px;" v-model="ckcount" placeholder="请输入库存数量"></el-input>
                      <el-button style="margin-top: 10px;" @click="savekc" type="success" plain>更新库存</el-button>
                    </div>
                    <i slot="reference" class="fa el-icon-sort fa-lg ciicon curpointer" v-on:click="changekc(scope.$index, goodsdata)"></i>
                  </el-popover>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="本地产品库存" name="goodskc">
          <el-table
            stripe
            id="orderdataid"
            :header-cell-style="{'text-align':'center'}"
            :data="goodsdata"
            ref="multipleTable">
            <el-table-column
              prop="product_code"
              label="条码">
            </el-table-column>
            <el-table-column
              prop="qty_available"
              label="库存数">
            </el-table-column>
            <el-table-column
              prop="qty_on_location"
              label="本地库存数">
            </el-table-column>
            <el-table-column
              label="操作"
              width="50px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="更改库存" placement="top-start">
                  <el-popover
                    placement="left"
                    width="260"
                    ref="popover"
                    trigger="click"
                    :value="showpop">
                    <div>
                      <el-select v-model="wsid" placeholder="请选择库房">
                        <el-option
                          v-for="item in wslist"
                          :key="item.id"
                          @click.native="selws(item)"
                          :label="item.sname"
                          :value="item.id">
                        </el-option>
                      </el-select>
                      <el-input style="margin-top: 10px;" v-model="ckcount" placeholder="请输入库存数量"></el-input>
                      <el-button style="margin-top: 10px;" @click="savekc" type="success" plain>更新库存</el-button>
                    </div>
                    <i slot="reference" class="fa el-icon-sort fa-lg ciicon curpointer" v-on:click="changekc(scope.$index, goodsdata)"></i>
                  </el-popover>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="商品损益" name="goodssy">
        </el-tab-pane>
      </el-tabs>
    </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'WsInfo',
    data () {
      return {
        activeName: 'cloudws',
        activeNames: ['1'],
        goodsdata: [],
        wslist: [],
        wsid: '',
        selwsitem: '',
        ckcount: '',
        curgid: '',
        showpop: false,
        goodslist: []
      }
    },
    mounted () {
      that = this
      that.queryws()
      that.querygoodslist()
    },
    methods: {
      querygoodslist () {
        that = this
        var qstr = {
          whereinfo: " ownphone='" + localStorage.getItem('phone') + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/queryginfo',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.goodslist = res.data
              that.querywsgoods()
            } else {
              that.goodslist = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      querywsgoods () {
        that = this
        var jsondata =
          {
            stock_id: '220126',
            owner_id: '340120',
            page_no: '1',
            page_size: '50'
          }
        var qstr = {
          param_json: JSON.stringify(jsondata),
          v_method: 'inventoryQuery',
          if_new: '1'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/runky',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            var tmpdata = JSON.parse(res.data.data)
            window.console.log(tmpdata)
            window.console.log(tmpdata.data.skus)
            var tmpdatas = tmpdata.data.skus
            for (var i = 0; i < tmpdatas.length; i++) {
              var tmpckgood = tmpdatas[i]
              var tmpckname = ''
              for (var j = 0; j < that.goodslist.length; j++) {
                // window.console.log(tmpckgood.product_code)
                // window.console.log(that.goodslist[j].barcode)
                if (tmpckgood.product_code === that.goodslist[j].barcode) {
                  // window.console.log(that.goodslist[j])
                  tmpckname = that.goodslist[j].name
                }
              }
              tmpckgood.goodsname = tmpckname
            }
            that.goodsdata = tmpdatas
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      selws (item) {
        window.console.log(item)
        this.selwsitem = item
      },
      changekc (index,data) {
        var datatmp = data[index]
        window.console.log('库存数据',datatmp)
        this.curgid = datatmp.id
      },
      savekc () {
        var adata = {
          sid: this.selwsitem.id.toString(),
          pid: this.selwsitem.spos.toString(),
          gid: this.curgid.toString(),
          gcount: this.ckcount.toString()
        }
        window.console.log(adata)
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/addwsgoods',
          method: 'post',
          data: adata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.result === 'success') {
              that.$message({
                type: 'success',
                message: '库存更新成功!'
              })
              that.showpop = false
              that.querywsgoods()
            } else {
              that.$message({
                type: 'error',
                message: '库存更新失败!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      queryws () {
        that = this
        var qstr = {
          whereinfo: ' cus_id = 1',
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querymystorage',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.wslist = res.data
            } else {
              that.wslist = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ws/WsInfo.vue